// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZvY3VzYWJsZT0iZmFsc2UiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEwIDZMOC41OSA3LjQxIDEzLjE3IDEybC00LjU4IDQuNTlMMTAgMThsNi02eiI+PC9wYXRoPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSVImporter_ImporterFrame {
  border: 1px solid #808080;
  padding: 1.2em;
  border-radius: 0.4em;
  background: #fff;
  width: 800px;
}
.CSVImporter_ImporterFrame__header {
  display: flex;
  align-items: center;
  margin-top: -1em;
  margin-bottom: 0.2em;
  margin-left: -1em;
}
.CSVImporter_ImporterFrame__headerTitle {
  padding-bottom: 0.1em;
  overflow: hidden;
  font-size: 1.15em;
  color: #202020;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.CSVImporter_ImporterFrame__headerCrumbSeparator {
  flex: none;
  display: flex;
  margin-right: 0.5em;
  margin-left: 0.5em;
  font-size: 1.2em;
  opacity: 0.5;
}
.CSVImporter_ImporterFrame__headerCrumbSeparator > span {
  display: block;
  width: 1em;
  height: 1em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
.CSVImporter_ImporterFrame__headerSubtitle {
  flex: none;
  padding-bottom: 0.1em;
  font-size: 1.15em;
  color: #202020;
}
.CSVImporter_ImporterFrame__footer {
  display: flex;
  align-items: center;
  margin-top: 1.2em;
}
.CSVImporter_ImporterFrame__footerFill {
  flex: 1 1 0;
}
.CSVImporter_ImporterFrame__footerError {
  flex: none;
  line-height: 0.8;
  color: #c00000;
  word-break: break-word;
}
.CSVImporter_ImporterFrame__footerSecondary {
  flex: none;
  display: flex;
  margin-left: 1em;
}
.CSVImporter_ImporterFrame__footerNext {
  flex: none;
  display: flex;
  margin-left: 1em;
}`, "",{"version":3,"sources":["webpack://./components/csv_import/ImporterFrame.scss","webpack://./theme.scss"],"names":[],"mappings":"AAGA;EACE,yBAAA;EACA,cAAA;EACA,oBCQa;EDPb,gBCJe;EDKf,YAAA;AAFF;AAIE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,qBAAA;EACA,gBAAA;EACA,iBCTY;EDUZ,cCdQ;EDeR,uBAAA;EACA,mBAAA;AAHJ;AAME;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAJJ;AAMI;EACE,cAAA;EACA,UAAA;EACA,WAAA;EAEA,yDAAA;EACA,4BAAA;EACA,4BAAA;EACA,sBAAA;AALN;AASE;EACE,UAAA;EACA,qBAAA;EACA,iBCtCY;EDuCZ,cC3CQ;ADoCZ;AAUE;EACE,aAAA;EACA,mBAAA;EAEA,iBAAA;AATJ;AAYE;EACE,WAAA;AAVJ;AAaE;EACE,UAAA;EACA,gBAAA;EACA,cCzDa;ED0Db,sBAAA;AAXJ;AAcE;EACE,UAAA;EACA,aAAA;EACA,gBAAA;AAZJ;AAeE;EACE,UAAA;EACA,aAAA;EACA,gBAAA;AAbJ","sourcesContent":["@import '../../theme.scss';\n\n// @todo use em instead of rem\n.CSVImporter_ImporterFrame {\n  border: 1px solid $controlBorderColor;\n  padding: 1.2em;\n  border-radius: $borderRadius;\n  background: $controlBgColor;\n  width:800px;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    margin-top: -1em; // cancel out button padding\n    margin-bottom: 0.2em;\n    margin-left: -1em;\n  }\n\n  &__headerTitle {\n    padding-bottom: 0.1em; // centering nudge\n    overflow: hidden;\n    font-size: $titleFontSize;\n    color: $textColor;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__headerCrumbSeparator {\n    flex: none;\n    display: flex; // for correct icon alignment\n    margin-right: 0.5em;\n    margin-left: 0.5em;\n    font-size: 1.2em;\n    opacity: 0.5;\n\n    > span {\n      display: block;\n      width: 1em;\n      height: 1em;\n      // MUI ChevronRight\n      background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZvY3VzYWJsZT0iZmFsc2UiIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTEwIDZMOC41OSA3LjQxIDEzLjE3IDEybC00LjU4IDQuNTlMMTAgMThsNi02eiI+PC9wYXRoPjwvc3ZnPg==');\n      background-position: 50% 50%;\n      background-repeat: no-repeat;\n      background-size: cover;\n    }\n  }\n\n  &__headerSubtitle {\n    flex: none;\n    padding-bottom: 0.1em; // centering nudge\n    font-size: $titleFontSize;\n    color: $textColor;\n  }\n\n  &__footer {\n    display: flex;\n    align-items: center;\n\n    margin-top: 1.2em;\n  }\n\n  &__footerFill {\n    flex: 1 1 0;\n  }\n\n  &__footerError {\n    flex: none;\n    line-height: 0.8; // in case of line break\n    color: $errorTextColor;\n    word-break: break-word;\n  }\n\n  &__footerSecondary {\n    flex: none;\n    display: flex; // for more consistent button alignment\n    margin-left: 1em;\n  }\n\n  &__footerNext {\n    flex: none;\n    display: flex; // for more consistent button alignment\n    margin-left: 1em;\n  }\n}\n","$fgColor: #000;\n$fillColor: #f0f0f0;\n$controlBorderColor: #808080;\n$controlBgColor: #fff;\n\n$invertedTextColor: #f0f0f0;\n$invertedBgColor: #404040;\n\n$textColor: #202020;\n$textSecondaryColor: #808080;\n$textDisabledColor: rgba($textColor, 0.5);\n$errorTextColor: #c00000;\n$titleFontSize: 1.15em; // relative to body font\n\n$borderRadius: 0.4em;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
